export const TRANSFER_OWNER_VALIDATIONS = [
    {
        name: "cpr",
        validations: ['required']
    },
    {
        name: "mobile",
        validations: ["length"],
        min_length: 8,
    },
]